<template>
  <div class="disconnected-popup">
    {{ textMessage }}
  </div>
</template>
<script lang="ts" src="./warning-message.ts"></script>
<style lang="scss" scoped src="./warning-message.scss"></style>
